export default {
  name: [
    {
      rule: 'notempty',
      parameters: [],
    },
    {
      rule: 'maxlengthequal',
      parameters: ['150'],
    },
  ],
  description: [
    {
      rule: 'notempty',
      parameters: [],
    },
    {
      rule: 'maxlengthequal',
      parameters: ['1000'],
    },
  ],
  active: [],
  owner: [],
  id: [],
  created: [],
  updated: [],
  deleted: [],
  version: [],
  processedMedia: [],
  released: [
    {
      rule: 'boolean',
      parameters: [],
    },
  ],
  media: [],
}
